const saveToStorage = function(key, val) {
  let video = sessionStorage.getItem('_video')
  if (!video) {
    video = {}
  } else {
    video = JSON.parse(video)
  }
  video[key] = val
  sessionStorage.setItem('_video', JSON.stringify(video))
}
const loadFromStorage = function(key, def) {
  let getVideo = sessionStorage.getItem('_video')
  if (!getVideo) {
    return def
  }
  getVideo = JSON.parse(getVideo)
  return getVideo[key] || def
}
export { saveToStorage, loadFromStorage }
